import React from "react";
import { Container, Row } from "react-bootstrap";
import "./footer.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logoImage from "./../../assets/images/logo.jpeg";
import { FcGoogle } from "react-icons/fc";
import { GrFacebook, GrTwitter, GrYoutube } from "react-icons/gr";

const Footer = () => {
  return (
    <Container className="pb-4">
      <hr />
      <Row className="justify-content-center">
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://www.facebook.com/pages/Sheikhalalfarms/1500976966827038?ref=bookmarks"
          className="d-block pr-2"
          style={{ color: "#4267B2" }}
        >
          <GrFacebook size={32} />
        </a>
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://twitter.com/sheikhalalfarms"
          className="d-block pr-2"
          style={{ color: "#1DA1F2" }}
        >
          <GrTwitter size={32} />
        </a>
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://plus.google.com/111776854433862536171"
          className="d-block pr-2"
        >
          <FcGoogle size={32} />
        </a>
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://www.youtube.com/channel/UCaBY_Toqc1SrEHu0vmKVpnQ"
          className="d-block pr-2"
          style={{ color: "#FF0000" }}
        >
          <GrYoutube size={32} />
        </a>
      </Row>
      <Row className="justify-content-center align-items-center">
        <div className=" pr-2">
          Sheik Halal Farms is approved and certified by Halal Monitoring
          Authority Canada ( HMA ).
        </div>
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://hmacanada.org/hma-certified-suppliers/"
          className="d-block pr-2"
        >
          <img
            src={logoImage}
            alt="Halal"
            className="img-fluid"
            style={{ height: "32px" }}
          />
        </a>
      </Row>
      <Row className="justify-content-center">
        <div className="pr-2">
          Etobicoke store, 12 Steinway Boulevard unit 18, Etobicoke, ON, M9W
          6M5.
        </div>
        <div className="pr-4">Tel: 416-675-1736, 416-576-4814</div>
        <div className="pr-2">Fax: 905-828-4561</div>
      </Row>
      <Row className="justify-content-center">
        Copyright © 2018 Sheik Halal Farms Inc. All rights reserved.
      </Row>
    </Container>
  );
};

export default Footer;
